import { FrontConfigurationFutureFlagsType } from 'src/models/FrontendConfiguration';
import { RootState } from 'src/store/store';

export const featureFlagsByFlagSelector =
  (flag: string) =>
  ({ featureFlags }: RootState): boolean =>
    featureFlags?.response ? featureFlags?.response[flag] === true : false;

export const featureFlagsSelector = ({ featureFlags }: RootState): FrontConfigurationFutureFlagsType =>
  featureFlags.response || {};
